import { EmailTemplate } from '@spike/email-marketing-model';
import { Table } from 'components/UI/V3/Table/Table';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { TableEmptyState } from 'components/UI/V3/Table/EmptyState/TableEmptyState';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { FunctionComponent } from 'react';
import EmailTemplatesRow from './Row/EmailTemplatesRow';
import styles from './EmailTemplatesList.module.scss';

interface EmailTemplatesListProps {
    templates: EmailTemplate[];
    page: number;
    totalPages: number;
    onChangePage: (page: number) => void;
    onDuplicateTemplate: (template: EmailTemplate) => void;
    onDeleteTemplate: (template: EmailTemplate) => void;
}

const EmailTemplatesList: FunctionComponent<EmailTemplatesListProps> = ({
    templates,
    page,
    totalPages,
    onChangePage,
    onDuplicateTemplate,
    onDeleteTemplate
}) => {
    if (templates.length === 0) {
        return (
            <Table
                fullHeight
                className={styles.emptyState}
            >
                <TableBody>
                    <TableEmptyState>
                        <h1>No templates found</h1>
                        <p>Click the &quot;New Email&quot; button to create a new template</p>
                    </TableEmptyState>
                </TableBody>
            </Table>
        );
    }

    return (
        <Table
            fullHeight
            firstColumnFixed
            className={styles.table}
            pagination={{ page, totalPages }}
            onPageChange={onChangePage}
        >
            <TableHeader className={styles.tableHeader}>
                <TableHeaderCell>Email</TableHeaderCell>
                <TableHeaderCell>Created</TableHeaderCell>
                <TableHeaderCell>Edited</TableHeaderCell>
                <TableHeaderCell />
            </TableHeader>
            <TableBody>
                {templates.map(template => (
                    <EmailTemplatesRow
                        key={template.id ?? template.uuid}
                        template={template}
                        onDuplicateTemplate={onDuplicateTemplate}
                        onDeleteTemplate={onDeleteTemplate}
                    />
                ))}
            </TableBody>
        </Table>
    );
};

export default EmailTemplatesList;
